"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _preact = _interopRequireWildcard(require("preact"));

var _HeadMenu = _interopRequireDefault(require("./HeadMenu"));

var _profile = _interopRequireDefault(require("../../assets/images/profile.svg"));

var _profileWhite = _interopRequireDefault(require("../../assets/images/profile-white.svg"));

var _ArrowLink = _interopRequireDefault(require("./ArrowLink"));

var _ProfileToggle = _interopRequireDefault(require("./ProfileToggle"));

var _function = require("../../utils/function.utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Profile = /*#__PURE__*/function (_Component) {
  _inherits(Profile, _Component);

  var _super = _createSuper(Profile);

  function Profile() {
    var _this;

    _classCallCheck(this, Profile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "menuRef", (0, _preact.createRef)());

    _defineProperty(_assertThisInitialized(_this), "_onClick", function () {
      var loginFunction = _this.props.loginFunction;

      if (_this.hasUser()) {
        _this.menuRef.current && _this.menuRef.current.toggleOpen();
      } else {
        (0, _function.callFunction)(loginFunction, 'onLogin');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_logout", function () {
      (0, _function.callFunction)(_this.props.logoutFunction, 'onLogout');
    });

    _defineProperty(_assertThisInitialized(_this), "hasUser", function () {
      return _this.props.user;
    });

    _defineProperty(_assertThisInitialized(_this), "userName", function () {
      if (_this.props.user) {
        return "".concat(_this.props.user.firstName || '').concat(_this.props.user.lastName ? " ".concat(_this.props.user.lastName) : '') || _this.props.noNameLabel;
      } else {
        return '';
      }
    });

    return _this;
  }

  _createClass(Profile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          user = _this$props.user,
          profileLinks = _this$props.profileLinks,
          toggleLabel = _this$props.toggleLabel,
          linksRenderFunction = _this$props.linksRenderFunction,
          logoutFunction = _this$props.logoutFunction,
          loginFunction = _this$props.loginFunction,
          loginAlt = _this$props.loginAlt,
          logoutAlt = _this$props.logoutAlt,
          label = _this$props.label,
          logoutLabel = _this$props.logoutLabel,
          toggleFunction = _this$props.toggleFunction;

      if (user || logoutFunction || loginFunction) {
        return (0, _preact.h)(_HeadMenu["default"], {
          id: "mtn-header-top-profile",
          ref: this.menuRef,
          alt: loginAlt,
          className: "mtn-o-header__profile",
          icon: user && user.avatarUrl || _profile["default"],
          greyIcon: true,
          fixedSize: !!(user && user.avatarUrl),
          label: this.hasUser() ? this.userName() : label,
          onOpen: this._onClick,
          content: this.hasUser() ? (0, _preact.h)("div", {
            className: "mtn-m-profile"
          }, (0, _preact.h)("div", {
            className: "mtn-m-profile__head",
            id: "mtn-header-top-profile-head"
          }, user.avatarUrl ? (0, _preact.h)("img", {
            id: "mtn-header-top-profile-avatar",
            alt: "",
            className: "mtn-m-profile__image",
            src: user.avatarUrl
          }) : (0, _preact.h)("span", {
            id: "mtn-header-top-profile-avatar",
            className: "mtn-m-profile__image--fallback"
          }, (0, _preact.h)("img", {
            alt: "",
            src: _profileWhite["default"]
          })), (0, _preact.h)("h3", {
            className: "mtn-ts-h5 u-mtn-color-text mtn-m-profile__title"
          }, this.userName()), toggleFunction && (0, _preact.h)(_ProfileToggle["default"], {
            checked: this.props.toggleChecked,
            onToggle: toggleFunction,
            label: toggleLabel
          })), (0, _preact.h)("ul", {
            id: "mtn-header-top-profile-links",
            className: "mtn-m-profile__links"
          }, profileLinks.map(function (link) {
            return (0, _preact.h)("li", {
              key: link.href,
              className: "mtn-m-profile__link"
            }, (0, _preact.h)(_ArrowLink["default"], {
              clickClassName: "js-mtn-close-headmenu",
              linksRenderFunction: linksRenderFunction,
              label: link.label,
              href: link.href
            }));
          })), logoutFunction ? (0, _preact.h)("button", {
            id: "mtn-header-top-profile-logout",
            onClick: this._logout,
            alt: logoutAlt,
            className: "a-button a-button--secondary mtn-m-profile__logout has-icon-left"
          }, (0, _preact.h)("span", {
            className: "fa fa-power-off"
          }), logoutLabel) : null) : null
        });
      }

      return null;
    }
  }]);

  return Profile;
}(_preact.Component);

Profile.defaultProps = {
  label: 'Aanmelden',
  logoutLabel: 'Afmelden',
  profileLinks: []
};
var _default = Profile;
exports["default"] = _default;